import { ApiClient } from 'utils/apiClient';

import fetcher from '../utils/api';

const documentMetadataService = {
  archiveDocumentMetadata: async (id) => fetcher(`document_metadata/${id}/archive/`, 'PATCH', true),
  unarchiveDocumentMetadata: async (id) => fetcher(`document_metadata/${id}/unarchive/`, 'PATCH', true),
  deleteDocumentMetadata: async (id) => fetcher(`document_metadata/${id}/`, 'DELETE', true),
  deleteAllArchived: async () => fetcher(`document_metadata/archived/`, 'DELETE', true),
  removeApplicationTag: async (documentMetadataId, domain, appTagId) => {
    return ApiClient.delete(`document_metadata/${documentMetadataId}/remove_application_tag`, { domain, appTagId }, true);
  },
  move: async ({ documentMetadataId, newOrganizationId }) => {
    return fetcher(`document_metadata/${documentMetadataId}/move`, 'POST', true, {
      organization_id: newOrganizationId
    });
  },
  updateDocumentMetadata: async (id, body) => fetcher(`document_metadata/${id}/`, 'PATCH', true, body),
  listVersions: async (id) => fetcher(`document_metadata/${id}/versions/`, 'GET', true),
  createVersion: async (id) => fetcher(`document_metadata/${id}/versions/new/`, 'POST', true),
  revertVersion: async (id, versionId) => fetcher(`document_metadata/${id}/versions/${versionId}/revert/`, 'POST', true)
};

export default documentMetadataService;
